module.exports = __webpack_public_path__ + "img/yamakami.4d322b2b.jpg";